<template>
  <div id="dashboard-content">
    <section id="pengajuan-het-detail">
      <div class="mb-4 d-flex">
        <h4>Detail Pengajuan HET</h4>
        <router-link
          to="/user/pengajuan-het"
          class="btn rounded-pill btn-secondary text-white ml-auto"
        >
          <i class="fa fa-arrow-left"></i> Kembali
        </router-link>
      </div>
    <template v-if="loading">
      <div class="text-center mt-5">
        <div class="spinner-border" role="status">
          <span class="sr-only">Loading...</span>
        </div>
        <p class="mt-3 text-muted">Memuat detail pengajuan HET...</p>
      </div>
    </template>

    <template v-else-if="error">
      <div class="text-center mt-5">
        <h5 class="text-danger">{{ error }}</h5>
        <p class="text-muted">Silakan kembali atau coba lagi nanti.</p>
        <div class="mt-3">
          <router-link to="/user/pengajuan-het" class="btn btn-secondary">Kembali</router-link>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="card p-3 border-0 shadow-sm">
        <!-- Cover Image -->
        <div v-if="data.kover_depan" class="mb-5">
          <!-- <label class="form-label font-weight-bold">Kover Depan</label> -->
          <div class="d-flex justify-content-center">
            <img :src="`https://static.sc.cloudapp.web.id/uploader/files/${data.kover_depan}`" alt="Kover Buku" class="cover-image" />
          </div>
        </div>
        <div class="row">
          <!-- Identitas Umum -->
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">NUIB</label>
              <p>{{ data.nuib || "-" }}</p>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Nama Penerbit</label>
              <p>{{ data.nama_penerbit || "-" }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Jenjang Sekolah</label>
              <p>{{ data.jenjang_sekolah_id || "-" }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Kelas</label>
              <p>{{ data.kelas || "-" }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Kategori</label>
              <p>{{ data.kategori || "-" }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Jenjang Buku</label>
              <p>{{ data.jenjang_buku_id || "-" }}</p>
            </div>
          </div>

          <!-- Properti Umum Buku -->
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">ISBN</label>
              <p>{{ data.isbn || "-" }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Judul Buku</label>
              <p>{{ data.judul_buku || "-" }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Nama Penulis</label>
              <p>{{ data.nama_penulis || "-" }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Mata Pelajaran</label>
              <p>{{ data.mata_pelajaran || "-" }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Tahun Terbit</label>
              <p>{{ data.tahun_terbit || "-" }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Edisi</label>
              <p>{{ data.edisi || "-" }}</p>
            </div>
          </div>

          <!-- Ukuran -->
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Bentuk Buku</label>
              <p>{{ data.bentuk_buku || "-" }}</p>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label class="form-label font-weight-bold">Lebar Buku (cm)</label>
              <p>{{ data.lebar_buku || "-" }}</p>
            </div>
          </div>

          <div class="col-md-3">
            <div class="form-group">
              <label class="form-label font-weight-bold">Panjang Buku (cm)</label>
              <p>{{ data.panjang_buku || "-" }}</p>
            </div>
          </div>

          <!-- Jumlah Halaman -->
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Jumlah Halaman Isi</label>
              <p>{{ data.jumlah_halaman_isi || "-" }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Jumlah Halaman Kulit</label>
              <p>{{ data.jumlah_halaman_kulit || "-" }}</p>
            </div>
          </div>

          <!-- Kertas Isi -->
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Kertas Isi (Jenis)</label>
              <p>{{ data.kertas_isi_jenis || "-" }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Kertas Isi (Gram)</label>
              <p>{{ data.kertas_isi_gram || "-" }}</p>
            </div>
          </div>

          <!-- Kertas Kulit -->
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Kertas Kulit (Jenis)</label>
              <p>{{ data.kertas_kulit_jenis || "-" }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Kertas Kulit (Gram)</label>
              <p>{{ data.kertas_kulit_gram || "-" }}</p>
            </div>
          </div>

          <!-- Warna -->
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Warna Isi</label>
              <p>{{ data.warna_isi || "-" }}</p>
            </div>
          </div>

          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Warna Kulit</label>
              <p>{{ data.warna_kulit || "-" }}</p>
            </div>
          </div>

          <!-- Teknik Jilid -->
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Teknik Jilid</label>
              <p>{{ data.finishing || "-" }}</p>
            </div>
          </div>

          <!-- Laminating -->
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Laminating</label>
              <p>{{ data.laminating || "-" }}</p>
            </div>
          </div>

          <!-- Finishing Options -->
          <div class="col-12">
            <div class="form-group">
              <label class="form-label font-weight-bold">Opsi Finishing Tambahan</label>
              <div class="row">
                <div class="col-md-3">
                  <p>
                    <i :class="data.emboss ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                    Emboss
                  </p>
                </div>
                <div class="col-md-3">
                  <p>
                    <i :class="data.spot_uv ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                    Spot UV
                  </p>
                </div>
                <div class="col-md-3">
                  <p>
                    <i :class="data.potong_sudut ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                    Potong Sudut
                  </p>
                </div>
                <div class="col-md-3">
                  <p>
                    <i :class="data.perlengkapan ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                    Perlengkapan
                  </p>
                </div>
                <div class="col-md-3">
                  <p>
                    <i :class="data.pond ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                    Pond
                  </p>
                </div>
                <div class="col-md-3">
                  <p>
                    <i :class="data.polymas ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                    Polymas
                  </p>
                </div>
                <div class="col-md-3">
                  <p>
                    <i :class="data.shrink ? 'fa fa-check text-success' : 'fa fa-times text-danger'"></i>
                    Shrink
                  </p>
                </div>
              </div>
            </div>
          </div>

          <!-- Stiker / Pembatas -->
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Stiker / Pembatas Buku</label>
              <p>{{ data.stiker_pembatas || "Tidak ada" }}</p>
            </div>
          </div>

          <!-- Status -->
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Status</label>
              <p>
                <span
                  :class="{
                    'text-success': data.status === 'approved',
                    'text-warning': data.status === 'pending',
                    'text-danger': data.status === 'rejected',
                    'text-danger': data.status === 'draft',
                    'text-secondary': !data.status || data.status === 'submitted'
                  }"
                >
                  {{ ucfirst(data.status) || "Submitted" }}
                </span>
              </p>
            </div>
          </div>

          <!-- Submission Date -->
          <div class="col-md-6">
            <div class="form-group">
              <label class="form-label font-weight-bold">Tanggal Pengajuan</label>
              <p>{{ formatDate(data.submission_date) }}</p>
            </div>
          </div>
        </div>

        <div class="d-flex justify-content-end mt-4" role="tablist">
          <router-link
            :to="{
              name: 'PengajuanHET-Edit',
              params: { id: data.id },
            }"
            class="btn btn-lg rounded-pill btn-secondary text-white"
          >
            <i class="fa fa-pencil-alt"></i> Edit
          </router-link>
        </div>
      </div>
    </template>
    </section>
  </div>
</template>

<script>
import Swal from "sweetalert2";

export default {
  name: "PengajuanHETDetail",
  data() {
    return {
      data: {},
      loading: false,
      error: null,
    };
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "-";
      try {
        const date = new Date(dateStr);
        return date.toLocaleDateString("id-ID", {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      } catch (e) {
        return dateStr;
      }
    },

    async loadDetailData() {
      this.loading = true;
      this.error = null;
      const id = this.$route.params.id;
      if (!id) {
        this.error = "ID tidak ditemukan pada route";
        this.loading = false;
        return;
      }

      try {
        const token = localStorage.getItem("token");
        if (!token) {
          this.error = "Token authorization tidak ditemukan. Silakan login.";
          this.loading = false;
          return;
        }

        const resp = await fetch(
          `https://het-buku.cloudapp.web.id/bookspec/book/${id}`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "X-API-Key": "dfjscmksi4395flSsafl402vlWdsflkWQ",
              "Content-Type": "application/json",
            },
          }
        );

        const result = await resp.json();

        if (result && result.data) {
          // Normalize: merge top-level and nested book fields so template can use data.<field>
          const d = result.data;
          this.data = Object.assign({}, d, d.book || {});
        } else {
          const msg = (result && result.message) || "Gagal memuat data detail";
          this.error = msg;
          Swal.fire({ title: "Gagal", text: msg, icon: "error" });
        }
      } catch (err) {
        console.error("Error loading HET detail:", err);
        this.error = "Terjadi kesalahan saat memuat data.";
        Swal.fire({ title: "Error", text: "Terjadi kesalahan saat memuat data.", icon: "error" });
      } finally {
        this.loading = false;
      }
    },
    ucfirst(str) {
      if (!str) return '';
      return str.charAt(0).toUpperCase() + str.slice(1);
    },
  },
  mounted() {
    this.loadDetailData();
  },
  beforeCreate() {
    const logged_in = localStorage.getItem("user");
    if (!logged_in) {
      this.$router.push("/login");
    }
  },
};
</script>

<style scoped>
.form-group p {
  margin-bottom: 0;
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
  word-break: break-word;
}

.badge {
  padding: 0.5rem 0.75rem;
  font-size: 0.875rem;
}

.cover-image {
  max-width: 300px;
  max-height: 400px;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  object-fit: cover;
}
</style>
